import React from "react";
import { useTranslation } from "react-i18next";

const Button = ({
  label,
  onClick,
  isLoading,
  icon,
  className,
  type,
  notShowLoading = false
}) => {
  const { t ,i18n} = useTranslation();
  return (
    <>
      <button
        type={type}
        className={`${className}`}
        onClick={onClick}
        disabled={isLoading}
      >
        {notShowLoading ? "" : isLoading && <i className={`fa fa-spinner fa-spin  ${i18n.language==="ar"?"ms-2":"me-2"}`}></i>}
        {t(label)}
        {icon && (
          <img className={`${i18n.language==="ar"?"me-2":"ms-2"}`} src={icon} alt="button_icon" height={14} />
        )}
      </button>
    </>
  );
};

export default Button;
